import type { Layer } from '@tsyl/karonte/lib/types/layers'

import type { OrganizationLayersTOC, OrganizationLayersTOCLoaded } from '@/types/OrganizationLayers'

export function filterTOC(toc: OrganizationLayersTOC[], filteredLayers: Layer[]): OrganizationLayersTOCLoaded[] {
  return toc
    .map((cat) => {
      const layerIds = cat.layers.map((l) => l.id)
      return {
        name: cat.name,
        layers: filteredLayers.filter((l) => layerIds.includes(l.id))
      }
    })
    .filter((cat) => cat.layers.length)
}
